<script setup lang="ts">
import FotoActividad from '@frontend/secciones/components/foto-actividad.vue';
import { textosSecciones as textos } from '@frontend/secciones/textos';

defineProps<{ actividad: { id: string; nombre: string; descripcion: string; foto: string | null } }>();
defineEmits<{ sacar: [] }>();
</script>

<template>
  <li :data-testid="`tarjeta-${actividad.id}`" class="flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
    <foto-actividad :actividad="actividad" />
    <div class="flex flex-1 flex-col gap-1 p-3">
      <h3 data-testid="actividad-en-seccion" class="font-semibold text-gray-900">{{ actividad.nombre }}</h3>
      <p data-testid="descripcion-actividad" class="line-clamp-3 flex-1 text-sm text-gray-600">{{ actividad.descripcion }}</p>
      <button
        :data-testid="`sacar-${actividad.id}`"
        class="mt-2 self-start text-sm font-medium text-red-600 hover:underline"
        @click="$emit('sacar')"
      >
        {{ textos.sacar }}
      </button>
    </div>
  </li>
</template>
